import { render, staticRenderFns } from "./TotalLuggageSentence.vue?vue&type=template&id=428716bb&scoped=true&"
import script from "./TotalLuggageSentence.vue?vue&type=script&lang=js&"
export * from "./TotalLuggageSentence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428716bb",
  null
  
)

/* custom blocks */
import block0 from "./TotalLuggageSentence.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports